// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b7-4";
export var closeButton = "_b7-6";
export var dismissButton = "_b7-3";
export var editImageWithAiContainer = "_b7-8";
export var imageUploadWrapper = "_b7-7";
export var misspelledWord = "_b7-5";
export var spellCheckContainer = "_b7-2";
export var spin = "_b7-1";
export var spinning = "_b7-0";